import {Button} from 'antd-mobile';
import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {receiveVipLevelReward, VipConfigVO} from '../vip.service';
import globalStore from '@/services/global.state';
import ReceivedModal, {ReceivedModalRef} from '../modal/level-received';
const PageReceiveButton = ({
  vip,
  onRefresh,
}: {
  vip: VipConfigVO;
  onRefresh: () => void;
}) => {
  const {t} = useTranslation();
  const levelReceivedModalRef = useRef<ReceivedModalRef>(null);
  const [received, setReceived] = useState(false);
  const handleReceive = () => {
    if (!vip.level) {
      return;
    }
    globalStore.globalLoading.next(true);
    receiveVipLevelReward(vip.level)
      .then(() => {
        levelReceivedModalRef.current?.show({
          spin: vip.spinCount || 0,
          scratchCard: vip.scratchCount || 0,
          money: vip.leveBonusAmount || 0,
        });
        onRefresh?.();
        setReceived(true);
      })
      .finally(() => globalStore.globalLoading.next(false));
  };
  useEffect(() => {
    setReceived(false);
  }, [vip.level]);
  return (
    <>
      {!received && vip.level && vip.rewardVipLevelReceivingStatus === 0 ? (
        <div className="pt-3 pb-6 px-5 bg-white" onClick={handleReceive}>
          <Button className="bg-c1 h-12 rounded-full w-full [&_span]:text-white [&_span]:text-sm [&_span]:font-bold">
            {t('label.receive')}
          </Button>
        </div>
      ) : null}
      <ReceivedModal ref={levelReceivedModalRef} />
      <div
        className="absolute invisible -top-[9999px] -left-[9999px]"
        style={{
          background: `url(${require('@/assets/imgs/vip/v2/level-bg.webp')})`,
        }}
      />
    </>
  );
};

export default PageReceiveButton;
